import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";

export default function StepReferences() {
    const { control } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;

    return (
        <div className="p-fluid">
            {[0, 1, 2].map((idx) => (
                <div className="formgrid grid" key={idx}>
                    <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                        <label>Nombre completo</label>
                        <Controller name={`referencias[${idx}].nombre`} control={control} render={({ field }) => (
                            <InputText {...field} className="w-full" />
                        )} />
                    </div>
                    <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                        <label>Contacto / Teléfono</label>
                        <Controller name={`referencias[${idx}].telefono`} control={control} render={({ field }) => (
                            <InputText {...field} className="w-full" />
                        )} />
                    </div>
                    <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                        <label>Parentesco</label>
                        <Controller name={`referencias[${idx}].parentesco`} control={control} render={({ field }) => (
                            <InputText {...field} className="w-full" />
                        )} />
                    </div>
                </div>
            ))}
        </div>
    );
}